/**
 * True when the cart has at least one item and every item is a sample portrait.
 * Sample-only orders have no deceased, so checkout must skip the name step.
 */
export function hasOnlySampleItems(items: ReadonlyArray<{ type?: string }>): boolean {
    return items.length > 0 && items.every((item) => item.type === "sample-portraits");
}
